import PLANNING_WORK_MODE from './planning-work-mode/en'

export default {
  hi: 'HI',
  USER_PROFIL: 'User Profile',
  SIGNOUT: 'Sign Out',
  MYPROFIL: 'My Profile',
  INFO: 'Account settings and more',
  UPDATE: 'update',
  Subscription: 'Subscription',
  DESC: 'description',
  PLANNING_WORK_MODE,
  UNSAVED: {
    TITLE: 'Unsaved changes',
    MESSAGE: 'You have unsaved changes. Leaving this screen will discard them.',
    SAVING: 'A save is in progress. Wait for confirmation before leaving this screen to avoid losing changes.',
    STAY: 'Stay',
    DISCARD: 'Leave without saving',
  },
}
